$(function () {
  $(".hasSub > a").on("click touchstart", function (e) {
      console.log('Event triggered444!');
      console.log('fzfz444!@ws')
      e.preventDefault();
      $(this).parent("li").toggleClass("hasSub-open");
      return false;
  });
});


// $(function () {
//   $("body").on("click", ".hasSub > i", function (e) {
//       e.preventDefault(); // Prevent default action of the click
//       $(this).parent("li").toggleClass("hasSub-open"); // Toggle the class 'hasSub-open' on the parent li
//       return false; // Stop event propagation
//   });
// });
